import React, { useState, useEffect } from 'react';
import Button from '../Button';
import { usePagingContext } from './PagingContext';

const Pages = ({ onPageChange }) => {
    const { paging, setPaging } = usePagingContext();

    const totalPages = Math.ceil(paging.totalItems / paging.itemsPerPage);

    const handlePrevClick = () => {
        if (paging.currentPage > 1) {
            onPageChange(paging.currentPage - 1);
        }
    };

    const handleNextClick = () => {
        if (paging.currentPage < totalPages) {
            onPageChange(paging.currentPage + 1);
        }
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];

        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(
                <li
                    key={i}
                    data-testid={`page${i}`}
                    onClick={() => {
                        onPageChange(i);
                    }}
                    className={`re-paging-item ${i === paging.currentPage ? 're-paging-number-disabled' : ''}`}
                >
                    <Button className="re-paging-item-btn" text={i.toString()} type="button" />
                </li>
            );
        }

        return pageNumbers;
    };

    return paging.totalItems > paging.itemsPerPage ? (
        <ul className="re-paging-items">
            <li
                data-testid="prev-page"
                className={`re-paging-item ${
                    paging.currentPage === 1 ? 're-paging-number-disabled' : ''
                }`}
                onClick={handlePrevClick}
            >
                <Button className="re-icon re-icon-sm re-icon-angle-left re-paging-item-btn" type="button" />
            </li>
            {renderPageNumbers()}
            <li
                data-testid="next-page"
                className={`re-paging-item ${
                    paging.currentPage === totalPages ? 're-paging-number-disabled' : ''
                }`}
                onClick={handleNextClick}
            >
                <Button className="re-icon re-icon-sm re-icon-angle-right re-paging-item-btn" type="button"/>
            </li>
        </ul>
    ) : null;
};

export default Pages;
